// extracted by mini-css-extract-plugin
module.exports = {"comingSoon":"ThumbnailNotice_comingSoon__2FMxr"};